import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AllCareerSearch } from "./models/all-career-search.model";
// import { PracticePath } from "./models/practice-path.model";
import { Practice } from "./models/practice.model";
import { Department } from "./models/department.model";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
  })
  export class CareerPathService {

    private ecpUrl = environment.apiUrl;
    private programIds = new BehaviorSubject<any>([0]);
    careerPathProgramIds = this.programIds.asObservable();

    constructor(private http: HttpClient) {
    }

    public setCareerrPathProgramIds(data: any) {
      this.programIds.next(data);
    }

    public get(searchModel: AllCareerSearch): Observable<any[]> {
      return this.http.post<any[]>(`${this.ecpUrl}AllCareer/GetAllCareerPath`, searchModel);
    }

    public getPractices(): Observable<Practice[]> {
      return this.http.get<Practice[]>(`${this.ecpUrl}Employee/GetPractices`);
    }

    public getDepartments(practiceId: number): Observable<Department[]> {
      return this.http.get<Department[]>(`${this.ecpUrl}Employee/GetDepartmentsByPracticeID?PracticeID=${practiceId}`);
    }

    public getAllPracticesAndDepartments() {
      return this.http.get(`${this.ecpUrl}ECPUser/FetchAllPracticesAndDepartments`);
    }

    public addCareerPathRequest(requestedProgram: any) {
      return this.http.post(`${this.ecpUrl}/AllCareer/CarrerPathRequest`, requestedProgram);
    }

    public fetchProgramsAndCourses(requestedDetails: any) {
      return this.http.post(`${this.ecpUrl}AllCareer/FetchProgramsAndCourses`, requestedDetails);
    }
  }
